// extracted by mini-css-extract-plugin
module.exports = {"root":"_2CXBg","title":"_2BVzl","subtitle":"_33G7C","order-number-line":"_10IKw","orderNumberLine":"_10IKw"};